import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Philosophy from "@/pages/Philosophy";
import Method from "@/pages/Method";
import Services from "@/pages/Services";
import Founder from "@/pages/Founder";
import Journal from "@/pages/Journal";
import Apply from "@/pages/Apply";
import Admin from "@/pages/Admin";

const PublicShell = () => (
  <LanguageProvider>
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/philosophy" element={<Philosophy />} />
        <Route path="/method" element={<Method />} />
        <Route path="/services" element={<Services />} />
        <Route path="/founder" element={<Founder />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/apply" element={<Apply />} />
      </Routes>
    </Layout>
  </LanguageProvider>
);

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="/*" element={<PublicShell />} />
          </Routes>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{ style: { background: "#111111", border: "1px solid rgba(198,168,124,0.3)", color: "#f4f1ed" } }}
          />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
